import React from 'react'

function ConnectCalenderIcon() {
  return (
    <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.125 1.125C7.125 0.501562 6.62344 0 6 0C5.37656 0 4.875 0.501562 4.875 1.125V3H3C1.34531 3 0 4.34531 0 6V6.75V9V21C0 22.6547 1.34531 24 3 24H18C19.6547 24 21 22.6547 21 21V9V6.75V6C21 4.34531 19.6547 3 18 3H16.125V1.125C16.125 0.501562 15.6234 0 15 0C14.3766 0 13.875 0.501562 13.875 1.125V3H7.125V1.125ZM2.25 9H18.75V21C18.75 21.4125 18.4125 21.75 18 21.75H3C2.5875 21.75 2.25 21.4125 2.25 21V9ZM10.5 10.875C9.87656 10.875 9.375 11.3766 9.375 12V14.25H7.125C6.50156 14.25 6 14.7516 6 15.375C6 15.9984 6.50156 16.5 7.125 16.5H9.375V18.75C9.375 19.3734 9.87656 19.875 10.5 19.875C11.1234 19.875 11.625 19.3734 11.625 18.75V16.5H13.875C14.4984 16.5 15 15.9984 15 15.375C15 14.7516 14.4984 14.25 13.875 14.25H11.625V12C11.625 11.3766 11.1234 10.875 10.5 10.875Z"
        fill="#5E06B9"
      />
    </svg>
  )
}

ConnectCalenderIcon.defaultProps = {
  className: '',
}
export default ConnectCalenderIcon
